import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const createCheckoutSession = async (productId, customerEmail = '') => {
  const originUrl = window.location.origin;
  const response = await axios.post(`${API}/payment/create-checkout`, {
    product_id: productId,
    origin_url: originUrl,
    customer_email: customerEmail,
  });
  return response.data;
};

export const pollPaymentStatus = async (sessionId) => {
  const response = await axios.get(`${API}/payment/status/${sessionId}`);
  return response.data;
};

export const getPreviewUrl = (productId) => {
  return `${API}/payment/preview/${productId}`;
};

export const getDownloadUrl = (productId, sessionId) => {
  return `${API}/payment/download/${productId}?session_id=${sessionId}`;
};

export const getRelatedProducts = async (productId) => {
  const response = await axios.get(`${API}/related/${productId}`);
  return response.data.products;
};

export const getUpsellOffer = async (productId) => {
  const response = await axios.get(`${API}/upsell/${productId}`);
  return response.data;
};

export const getPricingTiers = async (productId) => {
  const response = await axios.get(`${API}/pricing-tiers/${productId}`);
  return response.data;
};

export const createCustomBundleCheckout = async (guideIds) => {
  const response = await axios.post(`${API}/payment/create-custom-bundle-checkout`, {
    guide_ids: guideIds,
    origin_url: window.location.origin,
  });
  return response.data;
};
